module.exports = __webpack_public_path__ + "img/bg_2.3aaa3fcc.jpg";